import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import { GridColumns } from './Grid';
const Container = styled.div `
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 30px;

  ${({ collapse }) => collapse &&
    css `
      @media ${until(collapse)} {
        display: block;

        > ${() => Column} {
          margin-bottom: 30px;
        }
      }
    `}

  ${({ columns }) => {
    switch (columns) {
        case GridColumns.Half:
            return css `
          > ${() => Column} {
            @media ${from(Device.MobileLarge)} {
              grid-column: span 6;
            }
          }
        `;
        case GridColumns.Third:
            return css `
          > ${() => Column} {
            @media ${from(Device.MobileLarge)} {
              grid-column: span 6;
            }

            @media ${from(Device.DesktopSmall)} {
              grid-column: span 4;
            }
          }
        `;
        case GridColumns.Quarter:
            return css `
          > ${() => Column} {
            @media ${from(Device.MobileLarge)} {
              grid-column: span 6;
            }

            @media ${from(Device.DesktopSmall)} {
              grid-column: span 3;
            }
          }
        `;
        default:
            break;
    }
}}
`;
const Column = styled.div ``;
export default {
    Container,
    Column,
};
